'use strict';

var React = require('react'),
    UserStore = require('../stores/UserStore'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    AboutSection = require('../organisms/AboutSection'),
    ShortSignUp = require('../molecules/ShortSignUp'),
    ShortLogin = require('../molecules/ShortLogin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ScreenSizeMixin = require('../mixins/ScreenSizeMixin'),
    Button = require('../atoms/Button'),
    Icon = require('../atoms/Icon'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    createFlexibleImageQueueMixin = require('../mixins/createFlexibleImageQueueMixin'),
    config = require('config'),
    { PropTypes } = React;

require('./AboutCoverSection.less');

const iframeSrc = `//player.vimeo.com/video/120371713?autoplay=1&title=0&byline=0&badge=0`;
const backgroundImage = {
  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/24/2015/79a15771-c461-41e3-bf97-721a04ee3e3f.jpg',
  size: {
    width: 2048,
    height: 1152
  }
};

var AboutCoverSection = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, ScreenSizeMixin, createFlexibleImageQueueMixin(200)],

  propTypes: {
    layout: PropTypes.oneOf(['full', 'section', 'banner']).isRequired,
    active: PropTypes.bool.isRequired,
    showLogo: PropTypes.bool,
    showVideo: PropTypes.bool,
    onRequestShowVideoChange: PropTypes.func,
    footer: PropTypes.element
  },

  getImageOptions() {
    return {
      image: backgroundImage,
      sizes: {
        normal: true
      }
    };
  },

  getContentWindow() {
    if (this.refs.iframe) {
      return this.refs.iframe.getDOMNode().contentWindow;
    }
  },

  componentDidMount() {
    window.addEventListener('message', this.handleIframeMessage);
  },

  componentWillUnmount() {
    window.removeEventListener('message', this.handleIframeMessage);
  },

  getCSSModifiers() {
    return {
      inactive: !this.props.active
    };
  },

  render() {
    const { showVideo, layout, active, showLogo } = this.props;
    let { footer } = this.props;

    if (showVideo) {
      footer = null;
    }

    return (
      <AboutSection layout={layout}
                    active={active}
                    showLogo={showLogo}
                    title='A single place to share, curate and discover visual content that tells a story.'
                    backgroundColor='#222'
                    backgroundImage={this.getBackgroundImageUrl()}
                    color='white'
                    footer={footer}
                    needsTopMarginOnTablet={layout !== 'banner'}>
        {this.props.children || this.renderDefaultContent()}
        {this.renderLoaderImg()}
      </AboutSection>
    );
  },

  renderDefaultContent() {
    const { showVideo } = this.props;
    const { isMobile } = this.state;

    return (
      <div className={this.getClassName()}>
        {!showVideo &&
          <div className='AboutCoverSection-playButton'>
            <Button onClick={this.handleShowVideoClick}
                    color='light'
                    fill
                    size={isMobile ? 'xlarge' : 'xlarge'}
                    round>
              <Icon name='play'
                    size={isMobile ? 'medium' : 'medium'} />
            </Button>
          </div>
        }

        {!showVideo && !UserStore.isAuthenticated() &&
          <div className='AboutCoverSection-signUpWrapper'>
            {config.signUpEnabled ?
            <ShortSignUp color='light'
                         source={AnalyticsSources.ABOUT_PAGE_WELCOME} />
            :
            <ShortLogin color='light'
                         source={AnalyticsSources.ABOUT_PAGE_WELCOME} />
            }
          </div>
        }

        {showVideo &&
          <div className='AboutCoverSection-videoWrapper'>
            <iframe src={iframeSrc}
                    frameBorder='0'
                    webkitAllowFullScreen
                    mozAllowFullscreen
                    allowFullScreen
                    ref='iframe' />

            <div className='AboutCoverSection-closeVideoButton'>
              <Button size='large'
                      round
                      color='black'
                      overlay
                      onClick={this.handleHideVideoClick}>
                <Icon name='cross'
                      size='small'
                      mode='stroke' />
              </Button>
            </div>
          </div>
        }
      </div>
    );
  },

  handleShowVideoClick() {
    this.props.onRequestShowVideoChange(true);
  },

  handleHideVideoClick() {
    this.props.onRequestShowVideoChange(false);
  },

  handleIframeMessage(e) {
    if (!this.isMounted()) {
      return;
    }

    if (e.source !== this.getContentWindow()) {
      return;
    }

    var data = null;
    try {
      data = JSON.parse(e.data);
    } catch (err) {
      return;
    }

    switch (data.event) {
    case 'ready':
      this.postMessage('addEventListener', 'finish');
      break;

    case 'finish':
      this.handleVideoEnd();
      break;
    }
  },

  handleVideoEnd() {
    this.props.onRequestShowVideoChange(false);
  },

  postMessage(method, value) {
    const contentWindow = this.getContentWindow();
    if (contentWindow) {
      contentWindow.postMessage(JSON.stringify({ method, value }), iframeSrc);
    }
  }
});

module.exports = AboutCoverSection;



/** WEBPACK FOOTER **
 ** ./organisms/AboutCoverSection.jsx
 **/